import React from 'react'

const NoDataPerson = ({ className = '', color = '#000000' }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M5.01 4.491C5.4225 3.984 6.03 3.75 6.621 3.75H17.379C17.9685 3.75 18.576 3.984 18.99 4.491C19.857 5.553 21.75 8.292 21.75 12C21.75 15.708 19.857 18.4455 18.99 19.509C18.576 20.016 17.97 20.25 17.379 20.25H6.621C6.03 20.25 5.4225 20.016 5.01 19.509C4.143 18.4455 2.25 15.708 2.25 12C2.25 8.292 4.143 5.5545 5.01 4.491V4.491ZM6.621 5.25C6.53687 5.24602 6.45292 5.26093 6.37531 5.29363C6.2977 5.32634 6.2284 5.37601 6.1725 5.439C5.3985 6.3885 3.75 8.7945 3.75 12C3.75 15.2055 5.3985 17.61 6.1725 18.561C6.2625 18.6705 6.417 18.75 6.6225 18.75H17.3775C17.583 18.75 17.7375 18.6705 17.8275 18.561C18.6015 17.6115 20.25 15.2055 20.25 12C20.25 8.7945 18.6015 6.39 17.8275 5.439C17.7714 5.37581 17.7019 5.32601 17.624 5.2933C17.5461 5.26059 17.4619 5.24579 17.3775 5.25H6.6225H6.621Z"
        fill={color}
      />
      <path
        d="M9 8.25C9.19891 8.25 9.38968 8.32902 9.53033 8.46967C9.67098 8.61032 9.75 8.80109 9.75 9V11.25C9.75 11.4489 9.67098 11.6397 9.53033 11.7803C9.38968 11.921 9.19891 12 9 12C8.80109 12 8.61032 11.921 8.46967 11.7803C8.32902 11.6397 8.25 11.4489 8.25 11.25V9C8.25 8.80109 8.32902 8.61032 8.46967 8.46967C8.61032 8.32902 8.80109 8.25 9 8.25V8.25ZM15 8.25C15.1989 8.25 15.3897 8.32902 15.5303 8.46967C15.671 8.61032 15.75 8.80109 15.75 9V11.25C15.75 11.4489 15.671 11.6397 15.5303 11.7803C15.3897 11.921 15.1989 12 15 12C14.8011 12 14.6103 11.921 14.4697 11.7803C14.329 11.6397 14.25 11.4489 14.25 11.25V9C14.25 8.80109 14.329 8.61032 14.4697 8.46967C14.6103 8.32902 14.8011 8.25 15 8.25ZM10.5 15V16.5H13.5V15C13.5 14.6022 13.342 14.2206 13.0607 13.9393C12.7794 13.658 12.3978 13.5 12 13.5C11.6022 13.5 11.2206 13.658 10.9393 13.9393C10.658 14.2206 10.5 14.6022 10.5 15Z"
        fill={color}
      />
    </svg>
  )
}

export default NoDataPerson
